import { useState } from "react";

const useModuleMenu=()=>{
    const [showModuleMenu, setShowModuleMenu] = useState(false);
    const toggleMenuHandler = () => {
      setShowModuleMenu((prev) =>!prev);
    };

    return {
        showModuleMenu,toggleMenuHandler
    }
}
export default useModuleMenu